import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './HamburgerIcon.scss';

class HamburgerIcon extends PureComponent {
  static propTypes = {
    expanded: PropTypes.bool,
  };

  static defaultProps = {
    expanded: false,
  };

  render() {
    const { expanded } = this.props;
    return (
      <div
        className={classnames(styles.hamburger, {
          [styles.expanded]: expanded,
        })}
      >
        <span className={styles.top} />
        <span className={styles.center} />
        <span className={styles.center} />
        <span className={styles.bottom} />
      </div>
    );
  }
}

export default HamburgerIcon;



// WEBPACK FOOTER //
// ./src/icons/HamburgerIcon.jsx